<template>
    <div class="spinner-border spinner-border-sm" role="status">
        <span class="sr-only">Загрузка...</span>
    </div>
</template>

<script>
    export default {
        name: "SimpleSpinner"
    }
</script>

<style scoped>

</style>